// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Btn from "../../html/Btn.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__Checkbox from "../../html/Checkbox.js";
import * as Buhta_cabinet__Date from "../../../util/Date.js";
import * as Buhta_cabinet__Field from "../../html/Field.js";
import * as Buhta_cabinet__TaxControl from "../../../grpc/TaxControl.js";
import * as Buhta_cabinet__ToastSender from "../../../util/ToastSender.js";
import * as Buhta_cabinet__Toggle from "../../atoms/Toggle.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../packages/core/lib/Toast.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../../packages/util/lib/MelNumeral.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function OrgSettingsChief(Props) {
  const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match[1];
  const match$1 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$1[0];
  const match$2 = React.useState(function () {
    return "";
  });
  const setBirthday = match$2[1];
  const birthday = match$2[0];
  const match$3 = React.useState(function () {
    return "";
  });
  const setIin = match$3[1];
  const iin = match$3[0];
  const match$4 = React.useState(function () {
    return "";
  });
  const setLastname = match$4[1];
  const lastname = match$4[0];
  const match$5 = React.useState(function () {
    return "";
  });
  const setName = match$5[1];
  const name = match$5[0];
  const match$6 = React.useState(function () {
    return "";
  });
  const setSurname = match$6[1];
  const surname = match$6[0];
  const match$7 = React.useState(function () {
    return "";
  });
  const setPosition = match$7[1];
  const position = match$7[0];
  const match$8 = React.useState(function () {
    return "";
  });
  const setSalary = match$8[1];
  const salary = match$8[0];
  const match$9 = React.useState(function () {
    return false;
  });
  const setIsBenefit = match$9[1];
  const isBenefit = match$9[0];
  const match$10 = React.useState(function () {
    return false;
  });
  const setIsRetired = match$10[1];
  const isRetired = match$10[0];
  const match$11 = React.useState(function () {
    return "";
  });
  const setRetiredStartDate = match$11[1];
  const retiredStartDate = match$11[0];
  const match$12 = React.useState(function () {
    return false;
  });
  const setIsRetiredByYearsServed = match$12[1];
  const isRetiredByYearsServed = match$12[0];
  const match$13 = React.useState(function () {
    return "";
  });
  const setRetiredDutyStartDate = match$13[1];
  const retiredDutyStartDate = match$13[0];
  const match$14 = React.useState(function () {
    return false;
  });
  const setIsDisabled = match$14[1];
  const isDisabled = match$14[0];
  const match$15 = React.useState(function () {
    return "";
  });
  const setDisabledStartDate = match$15[1];
  const disabledStartDate = match$15[0];
  const match$16 = React.useState(function () {
    return "";
  });
  const setDisabledEndDate = match$16[1];
  const disabledEndDate = match$16[0];
  const match$17 = React.useState(function () {
    return false;
  });
  const setIsDisabledIndefinitely = match$17[1];
  const isDisabledIndefinitely = match$17[0];
  const match$18 = React.useState(function () {
    return "";
  });
  const setDisabledIndefinitelyStartDate = match$18[1];
  const disabledIndefinitelyStartDate = match$18[0];
  const match$19 = React.useState(function () {
    return false;
  });
  const setIsParent = match$19[1];
  const isParent = match$19[0];
  const match$20 = React.useState(function () {
    return "";
  });
  const setParentBenefitStartDate = match$20[1];
  const parentBenefitStartDate = match$20[0];
  const match$21 = React.useState(function () {
    return 0;
  });
  const setChildren = match$21[1];
  const children = match$21[0];
  const match$22 = React.useState(function () {
    return false;
  });
  const setIsMother = match$22[1];
  const isMother = match$22[0];
  const match$23 = React.useState(function () {
    return "";
  });
  const setMotherBenefitStartDate = match$23[1];
  const motherBenefitStartDate = match$23[0];
  const match$24 = React.useState(function () {
    return false;
  });
  const setIsStudent = match$24[1];
  const isStudent = match$24[0];
  const match$25 = React.useState(function () {
    return "";
  });
  const setStudentBenefitStartDate = match$25[1];
  const studentBenefitStartDate = match$25[0];
  const match$26 = React.useState(function () {
    return "";
  });
  const setStudentBenefitEndDate = match$26[1];
  const studentBenefitEndDate = match$26[0];
  const func = Buhta_cabinet__TaxControl.ChiefInformationService.view;
  const match$27 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._2(func, param, /* [] */ 0);
  }), undefined);
  const dispatch = match$27[1];
  const chief = match$27[0];
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), []);
  const currentChief = typeof chief === "string" || chief.NAME !== "Data" ? ({
      id: "",
      tin: "",
      resident: false,
      eaeu_resident: false,
      has_residence_permit: false,
      position: undefined,
      family_name: "",
      given_name: "",
      patronymic_name: undefined,
      start_date: undefined,
      category_benefits: /* [] */ 0,
      salary: undefined,
      mzp_salary: false,
      birthday_date: undefined,
      create_time: undefined,
      update_time: undefined
    }) : chief.VAL;
  React.useEffect((function () {
    if (typeof chief !== "string" && chief.NAME === "Data") {
      const chief$1 = chief.VAL;
      Curry._1(setIin, (function (param) {
        return chief$1.tin;
      }));
      Curry._1(setLastname, (function (param) {
        return chief$1.family_name;
      }));
      Curry._1(setName, (function (param) {
        return chief$1.given_name;
      }));
      Belt__Belt_Option.forEach(chief$1.position, (function (position) {
        Curry._1(setPosition, (function (param) {
          return position;
        }));
      }));
      Belt__Belt_Option.forEach(chief$1.patronymic_name, (function (name) {
        Curry._1(setSurname, (function (param) {
          return name;
        }));
      }));
      Belt__Belt_Option.forEach(chief$1.birthday_date, (function (date) {
        Curry._1(setBirthday, (function (param) {
          return Buhta_cabinet__Date.toString(date);
        }));
      }));
      Belt__Belt_Option.forEach(chief$1.salary, (function (salary) {
        Curry._1(setSalary, (function (param) {
          try {
            return salary.rate;
          }
          catch (raw_err){
            const err = Caml_js_exceptions.internalToOCamlException(raw_err);
            console.log(err);
            return "0";
          }
        }));
      }));
      Curry._1(setIsBenefit, (function (param) {
        return Belt__Belt_List.length(chief$1.category_benefits) > 0;
      }));
      const __x = chief$1.category_benefits;
      Belt__Belt_List.forEach(__x, (function (cb) {
        const match = cb.category;
        switch (match) {
          case /* PERSON_CATEGORY_PENSIONER_AGE */ 1 :
            Curry._1(setIsRetired, (function (param) {
              return true;
            }));
            return Curry._1(setRetiredStartDate, (function (param) {
              const date = cb.begin_date;
              if (date !== undefined) {
                return Buhta_cabinet__Date.toString(date);
              } else {
                return "";
              }
            }));
          case /* PERSON_CATEGORY_PENSIONER_DUTY */ 2 :
            Curry._1(setIsRetiredByYearsServed, (function (param) {
              return true;
            }));
            return Curry._1(setRetiredDutyStartDate, (function (param) {
              const date = cb.begin_date;
              if (date !== undefined) {
                return Buhta_cabinet__Date.toString(date);
              } else {
                return "";
              }
            }));
          case /* PERSON_CATEGORY_DISABLED_GROUP_2 */ 5 :
            Curry._1(setIsDisabled, (function (param) {
              return true;
            }));
            Curry._1(setDisabledStartDate, (function (param) {
              const date = cb.begin_date;
              if (date !== undefined) {
                return Buhta_cabinet__Date.toString(date);
              } else {
                return "";
              }
            }));
            return Curry._1(setDisabledEndDate, (function (param) {
              const match = cb.benefit;
              if (typeof match === "string") {
                return "";
              }
              if (match.NAME !== "Disabled") {
                return "";
              }
              const date = match.VAL.end_date;
              if (date !== undefined) {
                return Buhta_cabinet__Date.toString(date);
              } else {
                return "";
              }
            }));
          case /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */ 6 :
            Curry._1(setIsDisabledIndefinitely, (function (param) {
              return true;
            }));
            return Curry._1(setDisabledIndefinitelyStartDate, (function (param) {
              const date = cb.begin_date;
              if (date !== undefined) {
                return Buhta_cabinet__Date.toString(date);
              } else {
                return "";
              }
            }));
          case /* PERSON_CATEGORY_GUARDIAN_DISABLED */ 9 :
            Curry._1(setIsParent, (function (param) {
              return true;
            }));
            return Curry._1(setParentBenefitStartDate, (function (param) {
              const date = cb.begin_date;
              if (date !== undefined) {
                return Buhta_cabinet__Date.toString(date);
              } else {
                return "";
              }
            }));
          case /* PERSON_CATEGORY_MOTHER_MANY */ 15 :
            Curry._1(setIsMother, (function (param) {
              return true;
            }));
            return Curry._1(setMotherBenefitStartDate, (function (param) {
              const date = cb.begin_date;
              if (date !== undefined) {
                return Buhta_cabinet__Date.toString(date);
              } else {
                return "";
              }
            }));
          case /* PERSON_CATEGORY_STUDENT */ 16 :
            Curry._1(setIsStudent, (function (param) {
              return true;
            }));
            return Curry._1(setStudentBenefitStartDate, (function (param) {
              const date = cb.begin_date;
              if (date !== undefined) {
                return Buhta_cabinet__Date.toString(date);
              } else {
                return "";
              }
            }));
          default:
            return;
        }
      }));
    }
    
  }), [chief]);
  const saveSettings = function (ev) {
    ev.preventDefault();
    const retiredBenefit_begin_date = retiredStartDate !== "" ? Buhta_cabinet__Date.fromString(retiredStartDate) : undefined;
    const retiredBenefit_benefit = {
      NAME: "Pensioner_age",
      VAL: undefined
    };
    const retiredBenefit = {
      category: /* PERSON_CATEGORY_PENSIONER_AGE */ 1,
      begin_date: retiredBenefit_begin_date,
      benefit: retiredBenefit_benefit
    };
    const retiredDutyBenefit_begin_date = retiredDutyStartDate !== "" ? Buhta_cabinet__Date.fromString(retiredDutyStartDate) : undefined;
    const retiredDutyBenefit_benefit = {
      NAME: "Pensioner_duty",
      VAL: undefined
    };
    const retiredDutyBenefit = {
      category: /* PERSON_CATEGORY_PENSIONER_DUTY */ 2,
      begin_date: retiredDutyBenefit_begin_date,
      benefit: retiredDutyBenefit_benefit
    };
    const disabledBenefit_begin_date = disabledStartDate !== "" ? Buhta_cabinet__Date.fromString(disabledStartDate) : undefined;
    const disabledBenefit_benefit = {
      NAME: "Disabled",
      VAL: {
        end_date: disabledEndDate !== "" ? Buhta_cabinet__Date.fromString(disabledEndDate) : undefined
      }
    };
    const disabledBenefit = {
      category: /* PERSON_CATEGORY_DISABLED_GROUP_2 */ 5,
      begin_date: disabledBenefit_begin_date,
      benefit: disabledBenefit_benefit
    };
    const disabledIndefinitelyBenefit_begin_date = disabledIndefinitelyStartDate !== "" ? Buhta_cabinet__Date.fromString(disabledIndefinitelyStartDate) : undefined;
    const disabledIndefinitelyBenefit_benefit = {
      NAME: "Disabled_permanent",
      VAL: undefined
    };
    const disabledIndefinitelyBenefit = {
      category: /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */ 6,
      begin_date: disabledIndefinitelyBenefit_begin_date,
      benefit: disabledIndefinitelyBenefit_benefit
    };
    const parentBenefit_begin_date = parentBenefitStartDate !== "" ? Buhta_cabinet__Date.fromString(parentBenefitStartDate) : undefined;
    const parentBenefit_benefit = {
      NAME: "Guardian_disabled",
      VAL: {
        children: children > 0 ? children : undefined
      }
    };
    const parentBenefit = {
      category: /* PERSON_CATEGORY_GUARDIAN_DISABLED */ 9,
      begin_date: parentBenefit_begin_date,
      benefit: parentBenefit_benefit
    };
    const motherBenefit_begin_date = motherBenefitStartDate !== "" ? Buhta_cabinet__Date.fromString(motherBenefitStartDate) : undefined;
    const motherBenefit_benefit = {
      NAME: "Mother_many",
      VAL: undefined
    };
    const motherBenefit = {
      category: /* PERSON_CATEGORY_MOTHER_MANY */ 15,
      begin_date: motherBenefit_begin_date,
      benefit: motherBenefit_benefit
    };
    const studentBenefit_begin_date = studentBenefitStartDate !== "" ? Buhta_cabinet__Date.fromString(studentBenefitStartDate) : undefined;
    const studentBenefit_benefit = {
      NAME: "Student",
      VAL: {
        end_date: studentBenefitEndDate !== "" ? Buhta_cabinet__Date.fromString(studentBenefitEndDate) : undefined
      }
    };
    const studentBenefit = {
      category: /* PERSON_CATEGORY_STUDENT */ 16,
      begin_date: studentBenefit_begin_date,
      benefit: studentBenefit_benefit
    };
    const categoryBenefits = Stdlib.$at(/* [] */ 0, Stdlib.$at(isRetired ? ({
        hd: retiredBenefit,
        tl: /* [] */ 0
      }) : /* [] */ 0, Stdlib.$at(isRetiredByYearsServed ? ({
        hd: retiredDutyBenefit,
        tl: /* [] */ 0
      }) : /* [] */ 0, Stdlib.$at(isDisabled ? ({
        hd: disabledBenefit,
        tl: /* [] */ 0
      }) : /* [] */ 0, Stdlib.$at(isDisabledIndefinitely ? ({
        hd: disabledIndefinitelyBenefit,
        tl: /* [] */ 0
      }) : /* [] */ 0, Stdlib.$at(isParent ? ({
        hd: parentBenefit,
        tl: /* [] */ 0
      }) : /* [] */ 0, Stdlib.$at(isMother ? ({
        hd: motherBenefit,
        tl: /* [] */ 0
      }) : /* [] */ 0, isStudent ? ({
        hd: studentBenefit,
        tl: /* [] */ 0
      }) : /* [] */ 0)))))));
    const settingsForm_resident = currentChief.resident;
    const settingsForm_eaeu_resident = currentChief.eaeu_resident;
    const settingsForm_has_residence_permit = currentChief.has_residence_permit;
    const settingsForm_position = position !== "" ? position : undefined;
    const settingsForm_patronymic_name = surname !== "" ? surname : undefined;
    const settingsForm_salary = salary.length !== 0 ? ({
        rate: salary,
        gross_method: true
      }) : undefined;
    const settingsForm_mzp_salary = currentChief.mzp_salary;
    const settingsForm_birthday_date = birthday !== "" ? Buhta_cabinet__Date.fromString(birthday) : undefined;
    const settingsForm = {
      id: "",
      tin: iin,
      resident: settingsForm_resident,
      eaeu_resident: settingsForm_eaeu_resident,
      has_residence_permit: settingsForm_has_residence_permit,
      position: settingsForm_position,
      family_name: lastname,
      given_name: name,
      patronymic_name: settingsForm_patronymic_name,
      start_date: undefined,
      category_benefits: categoryBenefits,
      salary: settingsForm_salary,
      mzp_salary: settingsForm_mzp_salary,
      birthday_date: settingsForm_birthday_date,
      create_time: undefined,
      update_time: undefined
    };
    const __x = Buhta_cabinet__TaxControl.ChiefInformationService.update(tenant, settingsForm);
    $$Promise.get(__x, (function (result) {
      if (result.TAG === /* Ok */ 0) {
        return Curry._1(dispatchToasts, {
          TAG: /* Add */ 0,
          _0: {
            id: Buhta_core__Toast.generateId(undefined),
            text: "Настройки сохранены",
            kind: "success",
            onClick: (function (param) {
              
            })
          }
        });
      } else {
        return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при сохранении");
      }
    }));
  };
  return JsxRuntime.jsx("form", {
    children: typeof chief === "string" || chief.NAME !== "Data" ? null : JsxRuntime.jsxs(React.Fragment, {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                label: "ИИН",
                type_: "text",
                name: "iin",
                size: "m",
                required: true,
                onChange: (function (value) {
                  Curry._1(setIin, (function (param) {
                    return value;
                  }));
                }),
                value: iin
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    label: "Фамилия",
                    type_: "text",
                    name: "lastname",
                    size: "m",
                    required: true,
                    onChange: (function (value) {
                      Curry._1(setLastname, (function (param) {
                        return value;
                      }));
                    }),
                    value: lastname
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    label: "Имя",
                    type_: "text",
                    name: "name",
                    size: "m",
                    required: true,
                    onChange: (function (value) {
                      Curry._1(setName, (function (param) {
                        return value;
                      }));
                    }),
                    value: name
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    label: "Отчество",
                    type_: "text",
                    name: "surname",
                    size: "m",
                    onChange: (function (value) {
                      Curry._1(setSurname, (function (param) {
                        return value;
                      }));
                    }),
                    value: surname
                  })
                ],
                className: "flex gap-4 mt-6"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    label: "Должность",
                    type_: "text",
                    name: "position",
                    size: "m",
                    required: true,
                    onChange: (function (value) {
                      Curry._1(setPosition, (function (param) {
                        return value;
                      }));
                    }),
                    value: position
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                    value: birthday,
                    onPicked: (function (date) {
                      Curry._1(setBirthday, (function (param) {
                        return DateTime.toDateFormat(date);
                      }));
                    }),
                    align: "BottomLeft",
                    className: "w-full",
                    label: "Дата рождения"
                  })
                ],
                className: "flex gap-4 mt-6"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    label: "Доход руководителя",
                    type_: "text",
                    name: "salary",
                    size: "m",
                    required: true,
                    onChange: (function (value) {
                      const cleanValue = value.replace(/\s/g, "");
                      Curry._1(setSalary, (function (param) {
                        return cleanValue;
                      }));
                    }),
                    value: MelNumeral.formatSalary({
                      NAME: "Str",
                      VAL: salary
                    })
                  }),
                  JsxRuntime.jsx("img", {
                    className: "absolute right-4 top-4 w-5 h-5",
                    alt: "tenge",
                    src: StaticAsset.src("/static/icons/tenge.svg")
                  })
                ],
                className: "relative mt-6"
              }),
              JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                className: "text-asphalt mt-1",
                children: [
                  "Минимальная сумма — ",
                  JsxRuntime.jsx("button", {
                    children: MelNumeral.formatInt({
                      NAME: "Str",
                      VAL: "85000"
                    }) + " ₸",
                    className: "text-links",
                    type: "button",
                    onClick: (function (param) {
                      Curry._1(setSalary, (function (param) {
                        return "85000";
                      }));
                    })
                  })
                ]
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        children: "Применить льготы"
                      }),
                      JsxRuntime.jsx("img", {
                        className: "w-5 h-5",
                        alt: "info",
                        src: StaticAsset.src("/static/icons/info.svg")
                      })
                    ],
                    className: "flex gap-2 items-center"
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                    checked: isBenefit,
                    onChange: (function (value) {
                      Curry._1(setIsBenefit, (function (param) {
                        return value;
                      }));
                    })
                  })
                ],
                className: "flex justify-between items-center mt-6"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                    isChecked: isRetired,
                    onChange: (function (param) {
                      Curry._1(setIsRetired, (function (param) {
                        return !isRetired;
                      }));
                    }),
                    text: "Пенсионер по возрасту",
                    subText: "мужчины — 63, женщины — 61"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                      value: retiredStartDate,
                      onPicked: (function (date) {
                        Curry._1(setRetiredStartDate, (function (param) {
                          return DateTime.toDateFormat(date);
                        }));
                      }),
                      align: "BottomLeft",
                      label: "Дата начала льготы"
                    }),
                    className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isRetired))
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                        isChecked: isRetiredByYearsServed,
                        onChange: (function (param) {
                          Curry._1(setIsRetiredByYearsServed, (function (param) {
                            return !isRetiredByYearsServed;
                          }));
                        }),
                        text: "Пенсионер по выслуге лет"
                      }),
                      JsxRuntime.jsx("img", {
                        className: "w-5 h-5",
                        alt: "info",
                        src: StaticAsset.src("/static/icons/info.svg")
                      })
                    ],
                    className: "flex gap-2 items-center"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                      value: retiredDutyStartDate,
                      onPicked: (function (date) {
                        Curry._1(setRetiredDutyStartDate, (function (param) {
                          return DateTime.toDateFormat(date);
                        }));
                      }),
                      align: "BottomLeft",
                      label: "Дата начала льготы"
                    }),
                    className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isRetiredByYearsServed))
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                    isChecked: isDisabled,
                    onChange: (function (param) {
                      Curry._1(setIsDisabled, (function (param) {
                        return !isDisabled;
                      }));
                    }),
                    text: "Инвалид I, II, III группы"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                          value: disabledStartDate,
                          onPicked: (function (date) {
                            Curry._1(setDisabledStartDate, (function (param) {
                              return DateTime.toDateFormat(date);
                            }));
                          }),
                          align: "BottomLeft",
                          label: "Дата начала льготы"
                        }),
                        className: "grow"
                      }),
                      JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                          value: disabledEndDate,
                          onPicked: (function (date) {
                            Curry._1(setDisabledEndDate, (function (param) {
                              return DateTime.toDateFormat(date);
                            }));
                          }),
                          align: "BottomLeft",
                          label: "Дата окончания"
                        }),
                        className: "grow"
                      })
                    ],
                    className: Cn.$plus("mt-2 px-6 flex gap-4", Cn.on("hidden", !isDisabled))
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                    isChecked: isDisabledIndefinitely,
                    onChange: (function (param) {
                      Curry._1(setIsDisabledIndefinitely, (function (param) {
                        return !isDisabledIndefinitely;
                      }));
                    }),
                    text: "Инвалид I, II группы бессрочно"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                      value: disabledIndefinitelyStartDate,
                      onPicked: (function (date) {
                        Curry._1(setDisabledIndefinitelyStartDate, (function (param) {
                          return DateTime.toDateFormat(date);
                        }));
                      }),
                      align: "BottomLeft",
                      label: "Дата начала льготы"
                    }),
                    className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isDisabledIndefinitely))
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                    isChecked: isParent,
                    onChange: (function (param) {
                      Curry._1(setIsParent, (function (param) {
                        return !isParent;
                      }));
                    }),
                    text: "Родитель/опекун инвалида"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                        value: parentBenefitStartDate,
                        onPicked: (function (date) {
                          Curry._1(setParentBenefitStartDate, (function (param) {
                            return DateTime.toDateFormat(date);
                          }));
                        }),
                        align: "BottomLeft",
                        className: "w-[209px]",
                        label: "Дата начала льготы"
                      }),
                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                        label: "Количество детей",
                        type_: "text",
                        name: "children",
                        size: "m",
                        required: true,
                        onChange: (function (value) {
                          Curry._1(setChildren, (function (param) {
                            try {
                              return Caml_format.caml_int_of_string(value);
                            }
                            catch (exn){
                              return 0;
                            }
                          }));
                        }),
                        className: "w-[209px]",
                        value: String(children)
                      })
                    ],
                    className: Cn.$plus("mt-2 px-6 flex gap-4", Cn.on("hidden", !isParent))
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                    isChecked: isMother,
                    onChange: (function (param) {
                      Curry._1(setIsMother, (function (param) {
                        return !isMother;
                      }));
                    }),
                    text: "Многодетная мать",
                    subText: "4 и более детей"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                      value: motherBenefitStartDate,
                      onPicked: (function (date) {
                        Curry._1(setMotherBenefitStartDate, (function (param) {
                          return DateTime.toDateFormat(date);
                        }));
                      }),
                      align: "BottomLeft",
                      label: "Дата начала льготы"
                    }),
                    className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isMother))
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                    isChecked: isStudent,
                    onChange: (function (param) {
                      Curry._1(setIsStudent, (function (param) {
                        return !isStudent;
                      }));
                    }),
                    text: "Студент"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                        value: studentBenefitStartDate,
                        onPicked: (function (date) {
                          Curry._1(setStudentBenefitStartDate, (function (param) {
                            return DateTime.toDateFormat(date);
                          }));
                        }),
                        align: "BottomLeft",
                        className: "w-[209px]",
                        label: "Начало обучения"
                      }),
                      JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                        value: studentBenefitEndDate,
                        onPicked: (function (date) {
                          Curry._1(setStudentBenefitEndDate, (function (param) {
                            return DateTime.toDateFormat(date);
                          }));
                        }),
                        align: "BottomLeft",
                        className: "w-[209px]",
                        label: "Дата окончания"
                      })
                    ],
                    className: Cn.$plus("mt-2 px-6 flex gap-4", Cn.on("hidden", !isStudent))
                  })
                ],
                className: Cn.$plus("space-y-4 mt-4", Cn.on("hidden", !isBenefit))
              })
            ],
            className: "bg-white w-[562px] rounded-md shadow-kkm p-10"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
              title: "Сохранить",
              className: "px-6 py-3",
              type_: "submit"
            }),
            className: "w-[562px] flex justify-end mt-6"
          })
        ]
      }),
    className: "flex flex-col items-center py-6",
    onSubmit: saveSettings
  });
}

const make = OrgSettingsChief;

export {
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
